<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex">
        <h2>{{ $t("reports.dataScientist") }}</h2>
        <v-spacer></v-spacer>
        <v-select
          :items="category"
          item-text="name"
          item-value="id"
          color="primary"
          dense
          outlined
          @input="changedLabel"
          v-model="categories"
          class="shrink mr-2 wdt"
          :placeholder="$t('selectByCategory')"
        ></v-select>
      </div>
      <v-card elevation="0" class="px-5">
        <v-card-text>
          <div class="d-flex">
            <v-select
              :items="countries"
              item-text="name"
              item-value="id"
              dense
              outlined
              class="mr-2 wdt"
              v-model="countary"
              :placeholder="$t('reports.filterByCountry')"
            ></v-select>
            <v-select
              :items="regions"
              item-text="name"
              item-value="roleNumber"
              dense
              outlined
              class="mr-2 wdt"
              v-model="region"
              :placeholder="$t('reports.filterByRegion')"
            ></v-select>
            <v-autocomplete
              v-model="farm.farmNumber"
              :items="farmsList"
              item-text="name"
              item-value="farmNumber"
              dense
              :loading="farmLoading"
              :search-input.sync="farmSearch"
              outlined
              v-on:change="getProductByCat"
              hide-no-data
              :placeholder="$t('reports.filterByFarm')"
              class="mr-2 wdt"
            ></v-autocomplete>
            <v-select
              :items="regions"
              item-text="name"
              item-value="roleNumber"
              dense
              outlined
              class="mr-2 wdt"
              v-model="region"
              :placeholder="$t('reports.filterByTrait')"
            ></v-select>
            <v-select
              :items="regions"
              item-text="name"
              item-value="roleNumber"
              dense
              outlined
              class="mr-2 wdt"
              v-model="region"
              :placeholder="$t('reports.filterByYear')"
            ></v-select>
          </div>
          <div>
            <v-row no-gutters class="">
              <v-col>
                <v-card
                  class="mx-auto border rounded-lg mr-auto"
                  max-height="150"
                  elevation="2"
                  outlined
                >
                  <v-list-item>
                    <v-list-item-content>
                      <div class="inline">
                        <v-list-item-avatar
                          class="mb-5 float-left"
                          size="50"
                          color="grey"
                        ></v-list-item-avatar>
                        <div class="mt-2">
                          <v-list-item-title
                            class="text-h5 subtitle-2 font-weight-black mb-1"
                          >
                            {{ counts.semen }}
                          </v-list-item-title>
                          <v-list-item-subtitle
                            class="font-weight-medium text-h5"
                            >{{ $t("reports.semenProducts") }}</v-list-item-subtitle
                          >
                        </div>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
              <v-col cols="">
                <v-card
                  class="mx-auto border rounded-lg ml-2"
                  max-height="150"
                  elevation="2"
                  outlined
                >
                  <v-list-item>
                    <v-list-item-content>
                      <div class="inline">
                        <v-list-item-avatar
                          class="mb-5 float-left"
                          size="50"
                          color="grey"
                        ></v-list-item-avatar>
                        <div class="mt-2">
                          <v-list-item-title
                            class="text-h5 subtitle-2 font-weight-black mb-1"
                          >
                            {{ counts.diary }}
                          </v-list-item-title>
                          <v-list-item-subtitle
                            class="font-weight-medium text-h5"
                          >
                            {{ $t("reports.dairyProducts") }}</v-list-item-subtitle
                          >
                        </div>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
              <v-col>
                <v-card
                  class="mx-auto border rounded-lg ml-2"
                  max-height="150"
                  elevation="2"
                  outlined
                >
                  <v-list-item>
                    <v-list-item-content>
                      <div class="inline">
                        <v-list-item-avatar
                          class="mb-5 float-left"
                          size="50"
                          color="grey"
                        ></v-list-item-avatar>
                        <div class="mt-2">
                          <v-list-item-title
                            class="text-h5 subtitle-2 font-weight-black mb-1"
                          >
                            {{ counts.meat }}
                          </v-list-item-title>
                          <v-list-item-subtitle
                            class="font-weight-medium text-h5"
                            >{{ $t("reports.meatProducts") }}</v-list-item-subtitle
                          >
                        </div>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
              <v-col>
                <v-card
                  class="mx-auto border rounded-lg ml-2"
                  max-height="150"
                  elevation="2"
                  outlined
                >
                  <v-list-item>
                    <v-list-item-content>
                      <div class="inline">
                        <v-list-item-avatar
                          class="mb-5 float-left"
                          size="50"
                          color="grey"
                        ></v-list-item-avatar>
                        <div class="mt-2">
                          <v-list-item-title
                            class="text-h5 subtitle-2 font-weight-black mb-1"
                          >
                            {{ counts.totalProducts }}
                          </v-list-item-title>
                          <v-list-item-subtitle
                            class="font-weight-medium text-h5"
                            >{{ $t("reports.totalProducts") }}</v-list-item-subtitle
                          >
                        </div>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          </div>
          <div class="d-flex mt-5" v-if="items.length > 0">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              outlined
              height="5px"
              placeholder="Search"
              dense
              class="shrink"
              v-model="search"
              @click:append="searchItems"
              @input="resetSearchOnEmpty"
            ></v-text-field>
            <v-btn
              :disabled="search.length < 1"
              color="primary"
              height="40"
              width="40"
              max-width="40"
              outlined
              class="ml-8"
              @click="searchItems"
            >
              <v-icon>mdi-filter-outline</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              @click="exportToPDF"
            >
              <v-icon dark> mdi-export </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              fab
              small
              outlined
              color="primary"
              @click="
                printPDF(
                  $refs.document,
                  'Product Report(Analytics and Reporting)'
                )
              "
            >
              <v-icon dark> mdi-printer </v-icon>
            </v-btn>
          </div>
          <div ref="document">
            <v-row v-if="items.length > 0">
              <v-col cols="6" v-for="(item, index) in items" :key="index">
                <v-card flat elevation="0" outlined class="mt-5">
                  <v-toolbar dense flat :elevation="0">
                    <v-toolbar-title class="text-capitalize">{{
                      item.name
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn icon>
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text class="pa-0">
                    <v-data-table
                      :headers="productHeaders"
                      :items="newItems[index]"
                      :items-per-page="5"
                      :hide-default-footer="true"
                      :loading="loading"
                      loading-text="Loading Health Data..."
                      :options.sync="productOptions"
                      :server-items-length="totalProduct"
                    >
                      <!-- <template v-slot:progress>
              <v-progress-linear
                color="primary"
                :height="8"
                indeterminate
              ></v-progress-linear>
            </template>
                                        <template v-if="newItems[index].length > 0">
              <tbody>
                <tr
                  v-for="(item,index) in newItems[index]"
                  :key="index"
                  style="position: relative; width: 0; height: 0"
                >
                  <td>{{ item.name }}</td>
                  <td>{{ item.stockQty }} {{item.stockUom}}</td>
                  <td>{{ item.createdAt }}</td>
                </tr>
              </tbody>
            </template> -->
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-card v-else class="px-5 mt-5">
              <v-card-text class="text-center">
                <v-avatar size="135"> </v-avatar>
                <p class="text-h4 font-weight-bold">{{ $t("noRecordFound") }}</p>
                <p>{{ $t("reportings.dataNotAvailable") }}</p>
              </v-card-text>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import GeneralService from "@/_services/GeneralService";
import FarmService from "@/_services/farmService.js";
import ProductService from "@/_services/ReportingService.js";
import loadingMixin from "@/mixins/LoadingMixin";
import html2pdf from "html2pdf.js";
import printJS from "print-js";

export default {
  mounted() {
    document.title = this.$t('reports.analyticsAndReporting');
    this.loadOptions();
    this.getProductByCat();
    // this.searchFarm(this.farm);
  },

  watch: {
    async farmSearch(val) {
      await this.searchFarm(val);
    },
  },

  data() {
    return {
      counts: {},
      items: [],
      newItems: [],
      category: [],
      categories: 83,
      countries: [],
      farmsList: [],
      countary: null,
      region: null,
      loading: false,
      regions: [],
      farmLoading: false,
      farmSearch: "",
      loadSearch: "",
      search: "",
      farm: { farmNumber: "FRM000012397505" },
      selected: "",
      totalProduct: 10,
      productOptions: {
        page: 1,
        limit: 10,
      },
      productHeaders: [
        {
          text: this.$t('productName'),
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: this.$t('production'), sortable: false, value: "stockQty" },
        { text: this.$t('date'), sortable: false, value: "createdAt" },
      ],
      heavyMilkData: [
        {
          productName: "Heavy Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
        {
          productName: "Heavy Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
        {
          productName: "Heavy Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
        {
          productName: "Heavy Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
        {
          productName: "Heavy Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
        {
          productName: "Heavy Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
        {
          productName: "Heavy Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
      ],
      productData: [
        {
          productName: "Standard Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
        {
          productName: "Standard Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
        {
          productName: "Standard Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
        {
          productName: "Standard Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
        {
          productName: "Standard Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
        {
          productName: "Standard Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
        {
          productName: "Standard Milk",
          production: "30 gallons",
          date: "04/01/2022",
        },
      ],
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('reports.analyticsAndReporting'),
          disabled: true,
        },
        {
          text: this.$t('reports.productReport'),
          disabled: true,
        },
      ],
    }
  },
  methods: {
    async printPDF(reference, title) {
      let opt = {
        margin: 1,
        filename: `${title}.pdf`,
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(reference)
        .toCanvas()
        .outputPdf("blob", `${title}.pdf`);
      let file = new File([worker], `${title}.pdf`, {
        type: "application/pdf",
      });
      var pdfUrl = await URL.createObjectURL(file);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    loadOptions() {
      const options = {
        options: ["product-categories"],
      };
      GeneralService.getDropdownData(options).then((data) => {
        console.log(data);
        this.category = data.data["product-categories"];
      });
    },
    searchFarm(val) {
      if (val == "" || val == null) return;
      this.farmsLoading = true;
      FarmService.searchFarms(val)
        .then((res) => {
          console.log(res);
          this.farmsList = res.data.farms;
        })
        .catch((err) => {
          console.log(err);
          // this.users = [];
        })
        .finally(() => (this.farmsLoading = false));
    },
    exportToPDF() {
      html2pdf(this.$refs.document, {
        margin: 1,
        filename: "productReport.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    searchItems() {
      console.log(this.search);
      if (this.search == "") return;
      console.log(this.items);
      this.items = this.items.filter((item) => {
        return item.name.toLowerCase() == this.search.toLowerCase();
      });
    },
    resetSearchOnEmpty() {
      if (this.search != "") return;
      this.getProductByCat();
    },
    async changedLabel(event) {
      this.categories = event;
      await this.getProductByCat();
    },
    getProductByCat() {
      this.startLoading();
      ProductService.getFarmProducts(
        this.productOptions,
        this.categories,
        this.farm.farmNumber
      ).then(async (res) => {
        console.log(res);
        this.counts = res.data.productionReport.counts;
        this.items = res.data.productionReport.rows;
        if (this.newItems.length) {
          this.newItems.length = 0;
        }
        for (var i = 0; i < this.items.length; i++) {
          this.loading = true;
          console.log("index", i, this.items[i].productNumber);
          await ProductService.getProductLog(
            this.productOptions,
            this.items[i].productNumber,
            this.farm.farmNumber
          ).then((res) => {
            console.log(res);
            // this.newItems[i]=res.data.productionReport.rows;
            this.newItems.push(res.data.productionReport.rows);
            console.log(this.newItems);
            this.loading = false;
          });
        }
        this.stopLoading();
      });
    },
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
::v-deep .wdt {
  width: 175px;
}
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}
</style>